import $ from 'jquery'
import EditTaskPanelContainer from '../user/components/EditTaskPanelContainer'
import CreateTasksPopupController from '../addNewTasks/CreateTasksPopupController'
import CreateReportPopup from '../reports/dashboard/createReportPopup/CreateReportPopup'
import ChartMediator from '../reports/charts/ChartMediator'
import {unsafe_bindActions, unsafe_selectWithState} from '../redux/utils'
import {bindActionCreators} from 'redux'
import {supportPopupPositionStrategy} from '../support/supportForm/constants'
import {openEditTaskPanel} from '../panels/task/editPanel/actions'
import {openSupportForm} from '../support/supportForm/actions'
import {getLoggedInUser} from '../loggedInUser/selectors'
import {currentUsedUserCount} from '../activeLicenseInfo/selectors'
import {setEventPreventHidingEditTaskSlidingPanel} from '../panels/utils'
import {reportNameKeys, reportUrls} from './constants'

class NextBridge {
    listeners = {
        taskPanelClosed: [],
        tasksCreated: [],
        taskDeleted: [],
        taskMoved: [],
        taskUpdated: [],
        projectDeleted: [],
        profileSettingsChanged: [],
        tipsToggled: [],
        chartSaved: [],
        chartClosed: [],
    }

    basePath = window.BASE_PATH

    GlobalConstants = window.__GENERATED_CONSTANTS__
    SystemSettings = window.SystemSettings

    stripeJsAuthKey = window.StripeConfig.KEY

    _init() {
        this.actions = unsafe_bindActions((dispatch) => ({
            openSupportForm: bindActionCreators(openSupportForm, dispatch),
            openEditTaskPanel: bindActionCreators(openEditTaskPanel, dispatch),
        }))

        $(document).on('close_user_profile_event', () => {
            this.listeners.profileSettingsChanged.forEach(handler => handler())
        })

        $(document).on('toggle_tips_event', (e, {enabled}) => {
            this.listeners.tipsToggled.forEach(handler => handler(enabled))
        })
    }

    /**
     * Get tips enabled value from cookies for defining the initial value
     */
    areTipsEnabled() {
        return $.cookie('at-tips-enabled') || false
    }

    /**
     * Get logged in user from classic store
     */
    getMe() {
        return unsafe_selectWithState(state => getLoggedInUser(state))
    }

    /**
     * Init components necessary for enterTT
     */
    initEnterTT() {
        this._init()
        this.initNewTaskPopup()
    }

    initReports() {
        this._init()
        this.initCreateReportPopup()
        this.initCreateChartPopup()
    }

    initCustomFieldsList() {
        this._init()
    }

    initCustomFieldsReport() {
        this._init()
        this.initCreateReportPopup()
    }

    initLicenses() {
        this._init()
    }

    /**
     * Used only for lazy initialization
     */
    initTaskPanel() {
        this.editTaskPanelContainer = new EditTaskPanelContainer({
            onTaskDeletedCb: (taskId) => this.listeners.taskDeleted.forEach(handler => handler(taskId)),
            onTaskMovedCb: taskId => this.listeners.taskMoved.forEach(handler => handler(taskId)),
        })
        $(document).on('editTaskPanel_updateTask', (e, {taskId}) => {
            this.listeners.taskUpdated.forEach(handler => handler(taskId))
        })
        $(document).on('editTaskPanel_projectDeleted', (e, {projectId}) => {
            this.listeners.projectDeleted.forEach(handler => handler(projectId))
        })
        this.editTaskPanelContainer.init()
        this.editTaskPanelContainer.onStatePropertyBecameValue('isShown', false, () =>
            this.listeners.taskPanelClosed.forEach(handler => handler()))
    }

    initNewTaskPopup() {
        this.createTasksPopupController = new CreateTasksPopupController({
            successTaskCreationCb: (result) => this.listeners.tasksCreated.forEach(handler => handler(result)),
            serviceName: "AddNewTasksService"
        })

        window.onloadLightbox = () => {
            if (window.editDescriptionPopup.hide()) {
                window.editDescriptionPopup.showAboveBasicPopups()
                return true
            }
            return false
        }
        window.onHideLightBox = () => {
            window.editDescriptionPopup.showUnderBasicPopups()
        }
    }

    /**
     * Open side task panel for specified taskId
     * @param taskId - classic task id
     * @param event - mouse event that caused the action
     */
    openTaskPanel(taskId, event) {
        if (!this.editTaskPanelContainer) {
            this.initTaskPanel()
        }
        setEventPreventHidingEditTaskSlidingPanel($.Event(event))
        this.actions.openEditTaskPanel(taskId)
    }

    /**
     * Open new task popup for specified user and dayOnWeek
     * @param selectedUserId
     * @param submitTtDate
     */
    openNewTaskPopup(selectedUserId, submitTtDate) {
        this.createTasksPopupController.showPopup(null, null, selectedUserId, false, submitTtDate)
    }

    getLicensesData() {
        return {
            currentUsedUserCount: unsafe_selectWithState(state => currentUsedUserCount(state))
        }
    }

    /**
     * Subscribe to classic interface events.
     * - taskPanelClosed
     * - tasksCreated
     * - taskDeleted
     * - taskMoved
     * @param handlers - list of handlers in {[key:string] : handler: (data: any) => void}
     */
    subscribeToEvent(handlers) {
        Object.keys(handlers).forEach(name => {
            const handler = handlers[name]
            if (!this.listeners[name]) throw new Error("Invalid event name " + name)
            if (!this.listeners[name].find(h => h === handler))
                this.listeners[name].push(handler)
        })
    }

    /**
     * Open support form
     * @param positionParams - forms positioning params:
     *  positionStrategy can take the values: 'center', 'fromTopLeft', 'fromBottomRight'
     *  position takes the coordinates
     */
    openSupportForm(positionParams = {
        positionStrategy: supportPopupPositionStrategy.CENTER,
        position: {x: 0, y: 0,},
    }) {
        this.actions.openSupportForm(positionParams)
    }

    /**
     * Opens user profile settings popup (profile.do)
     */
    openProfileSettingsPopup(highlightStartingNewWeekSection = false) {
        $(document).trigger('open_user_profile_event', [highlightStartingNewWeekSection])
    }

    initCreateReportPopup() {
        this.createReportPopup = new CreateReportPopup({
            reportUrls: reportUrls,
            reportNameKeys: reportNameKeys,
        }).init()
    }

    initCreateChartPopup() {
        this.chartMediator = new ChartMediator(false, false)
        $(document).on('chartSaved', (e, {chartId}) => {
            this.listeners.chartSaved.forEach(handler => handler(chartId))
        })
        $(document).on('chartClosed', (e, {chartId}) => {
            this.listeners.chartClosed.forEach(handler => handler(chartId))
        })
    }

    /**
     * Opens create report popup
     */
    openCreateReportPopup() {
        this.createReportPopup.show()
    }

    /**
     * Opens chart popup for create
     */
    openCreateChartPopup() {
        this.chartMediator.loadNewChartData()
    }

    /**
     * Opens chart popup for edit
     * @param configId - chart configuration identifier
     */
    openEditChartPopup(configId) {
        this.chartMediator.showChart(configId)
    }
}

const nextBridge = new NextBridge()
export default nextBridge



// WEBPACK FOOTER //
// ./web/js/next/NextBridge.js